import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../../api/client'
import { formatUsd } from './pulseTotals.js'
import { formatInstantMonthDay } from '../../lib/localDate.ts'
import PulseDocPanel from './PulseDocPanel'

type CoRow = {
  id: number
  description?: string
  amount?: string | number
  created_at?: string
  approved_at?: string | null
  attachment_id?: number | null
}

export default function PulseCoPanel({
  projectId,
  coId,
}: {
  projectId: number
  coId: number
}) {
  const q = useQuery({
    queryKey: ['pulse-cos', projectId],
    queryFn: async () => {
      const rows = await apiFetch<CoRow[] | { data: CoRow[] }>('GET', `/api/projects/${projectId}/change-orders`)
      return Array.isArray(rows) ? rows : (rows.data || [])
    },
  })
  const attQ = useQuery({
    queryKey: ['pulse-atts', projectId],
    queryFn: async () => {
      const rows = await apiFetch<Array<{ id: number; change_order_id?: number }> | { data: Array<{ id: number; change_order_id?: number }> }>(
        'GET',
        `/api/projects/${projectId}/attachments`,
      )
      return Array.isArray(rows) ? rows : (rows.data || [])
    },
  })
  const co = (q.data || []).find((r) => Number(r.id) === coId)
  const att = (attQ.data || []).find((a) => Number(a.change_order_id) === coId)
  if (q.isLoading) return <p>Loading…</p>
  if (!co) return <p data-testid="pulse-co-missing">Change order not found.</p>
  const when = co.approved_at || co.created_at
  return (
    <div data-testid="pulse-co-detail">
      <h2 className="pulse-detail-title">{co.description || `Change order #${co.id}`}</h2>
      <div className="pulse-detail-metrics">
        <div>
          <label>Approved value</label>
          <strong data-testid="pulse-co-amount">{formatUsd(co.amount)}</strong>
        </div>
      </div>
      {when ? <p className="pulse-row-meta" data-testid="pulse-co-date">{formatInstantMonthDay(when)}</p> : null}
      {att ? <PulseDocPanel projectId={projectId} open={{ kind: 'document', source: 'att', id: Number(att.id) }} /> : null}
    </div>
  )
}
